//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CoreEmptyState',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      commonAttrs: {}
    };
  },
  computed: {
    hasEmptySlot: function hasEmptySlot() {
      return Boolean(!this.$slots.default);
    }
  }
};